function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import cx from "classnames";
import { useUIDSeed } from "react-uid";
import { Body, Button, ErrorMessage } from "../../atoms";
import { ArrowRight } from "../../icons";
import { OfficeInfoBlock, Section, SectionHeader } from "../../molecules";
import { GenericForm } from "../GenericForm";
export function ContactForm(param) {
    var label = param.label, title = param.title, titleAs = param.titleAs, titleVariant = param.titleVariant, description = param.description, officeInformation = param.officeInformation, formConfig = param.formConfig, submitContent = param.submitContent, className = param.className, onSubmit = param.onSubmit, enableLines = param.enableLines, formContent = param.formContent, successContent = param.successContent, errorContent = param.errorContent, isSubmitting = param.isSubmitting, fullWidth = param.fullWidth;
    var seed = useUIDSeed();
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", null, !!title && /*#__PURE__*/ React.createElement(SectionHeader, {
        label: label,
        title: title,
        titleAs: titleAs,
        titleVariant: titleVariant
    }), /*#__PURE__*/ React.createElement("div", {
        className: cx("mt-7 grid grid-cols-1 gap-7 md:gap-10 md:mt-10", !fullWidth && "md:grid-cols-2")
    }, (!fullWidth || !!description || !!(officeInformation === null || officeInformation === void 0 ? void 0 : officeInformation.length)) && /*#__PURE__*/ React.createElement("div", null, !!description && /*#__PURE__*/ React.createElement(Body, {
        variant: "default",
        className: cx("prose prose-md", (!fullWidth || !!(officeInformation === null || officeInformation === void 0 ? void 0 : officeInformation.length)) && "mb-7 md:mb-10")
    }, description), !!(officeInformation === null || officeInformation === void 0 ? void 0 : officeInformation.length) && /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-flow-row auto-rows-auto gap-7 grid-cols-2 md:gap-10"
    }, officeInformation.map(function(office) {
        return /*#__PURE__*/ React.createElement(OfficeInfoBlock, {
            key: seed(office),
            country: office.country
        }, office.info);
    }))), /*#__PURE__*/ React.createElement("div", null, successContent ? /*#__PURE__*/ React.createElement("div", null, successContent) : /*#__PURE__*/ React.createElement(GenericForm, _extends({}, formConfig, {
        onSubmit: onSubmit
    }), !!formContent && /*#__PURE__*/ React.createElement("div", null, formContent), !!errorContent && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(ErrorMessage, null, errorContent)), /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-end"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "submit",
        name: "submit",
        variant: "primary",
        disabled: isSubmitting,
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
    }, submitContent)))))));
}

//# sourceMappingURL=ContactForm.js.map